import React from 'react';

const RotateSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 12c0-3.8 3.1-6.8 6.8-6.8.6 0 1.1.1 1.7.2L11.9 7l.7.7 2.8-2.8L12.7 2l-.7.7 1.7 1.7c-.6-.1-1.2-.2-1.8-.2C7.5 4.2 4 7.7 4 12c0 2.2 1 4.4 2.6 5.9l.7-.7C5.8 15.8 5 14 5 12zm12-5.9l-.7.7c1.5 1.3 2.3 3.2 2.3 5.1 0 3.8-3.1 6.8-6.8 6.8-.6 0-1.1-.1-1.7-.2l1.6-1.6-.7-.6-2.8 2.8L11 22l.7-.7-1.7-1.7c.6.1 1.2.2 1.8.2 4.3 0 7.8-3.5 7.8-7.8 0-2.2-.9-4.4-2.6-5.9z"
        />
    </svg>
);

RotateSvg.displayName = 'RotateSvg';
export default RotateSvg;
